import { useEffect, useState } from 'react';
import { SelMenu, useZstdDlCenter } from '../useZstdDlCenter';

export const useMenuOpenClose = (menu: SelMenu) => {
  const [open, setOpen] = useState(false);
  const { selMenu, setSelMenu } = useZstdDlCenter();
  useEffect(() => {
    if (selMenu === menu) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [selMenu]);

  useEffect(() => {
    if (open) {
      setSelMenu(menu);
    } else {
      if (selMenu === menu) {
        setSelMenu('');
      }
    }
  }, [open]);

  return { open, setOpen, selMenu };
};
